import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5969a3eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-5",
  class: "page-5"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, " 오프라인 참여 일정 ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("2개월간 다양한 상점에서 "),
    /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
    /*#__PURE__*/_createTextVNode("캡틴쓱과 함께 종이팩 수거 장소로 활동해 주실 예정이에요.")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("p", null, "종이팩 전용 수거함이 가까이에 없다면?"),
  /*#__PURE__*/_createElementVNode("p", null, "아쉽게도 온라인 캠페인 참여자로 선정되지 못했다면?")
], -1))
const _hoisted_7 = { class: "steps" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("p", null, "오프라인 수거 시 리워드는 지급되지 않습니다."),
  /*#__PURE__*/_createElementVNode("p", null, "환경을 위한 노력에 진심으로 감사드립니다.")
], -1))

import Recycle from '../images/page-5/recycle.png';
import Step1 from '../images/page-5/step-1.png';
import Step2 from '../images/page-5/step-2.png';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(Recycle),
        class: "recycle"
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: _unref(Step1),
          class: "step"
        }, null, 8, _hoisted_8),
        _createElementVNode("img", {
          src: _unref(Step2),
          class: "step"
        }, null, 8, _hoisted_9)
      ]),
      _hoisted_10
    ])
  ]))
}
}

})